import { ApplicationConfig, importProvidersFrom } from "@angular/core";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { HttpClient, provideHttpClient, withInterceptors } from "@angular/common/http";
import { provideRouter, withRouterConfig } from "@angular/router";
import { routerConfig, routes } from "./app.routes";
import { NgPipesModule } from "ngx-pipes";
import { DialogService } from "primeng/dynamicdialog";
import { cacheInterceptor } from "@shared/interceptors/cache-interceptor/cache-interceptor.interceptor";
import { provideNoopAnimations } from "@angular/platform-browser/animations";
import { httpLoaderFactory } from "@shared/factories/http-loader/http-loader.factory";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withRouterConfig(routerConfig)),
    provideHttpClient(withInterceptors([cacheInterceptor])),
    provideNoopAnimations(),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps: [HttpClient]
        }
      }),
      NgPipesModule
    ),
    DialogService
  ]
}
